import { StyleSheet } from "@react-pdf/renderer";
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 30,
  },
  header: {
    alignItems: "center",
    marginBottom: 20,
  },
  logo: {
    width: 150,
    height: "auto",
    objectFit: "contain",
    textAlign: "center",
  },
  section: {
    margin: 10,
    padding: 10,
  },
  //TODO: Uncomment and customize these styles if needed
  // company: {
  //   fontSize: 28,
  //   marginBottom: 5,
  //   textAlign: "center",
  // },
  // companySlogan: {
  //   fontSize: 12,
  //   marginBottom: 20,
  //   textAlign: "center",
  // },
  title: {
    fontSize: 24,
    marginBottom: 20,
    textAlign: "center",
  },
  questionSection: {
    marginBottom: 15,
  },
  question: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#005aa7",
  },
  answer: {
    fontSize: 12,
    marginBottom: 10,
  },
  arrayItem: {
    fontSize: 12,
    marginLeft: 20,
    marginBottom: 5,
  },
  nestedItem: {
    fontSize: 12,
    marginLeft: 20,
    marginBottom: 5,
  },
});

export default styles;
